// ENOTFOUND happens when disconnecting from wifi
// ETIMOUT happens when physically unplugging the internet cable
export const RegexConnectionError = /.+(ENOTFOUND|ETIMEOUT).+/i;
